// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import AmountSelectorController from "./amount_selector_controller";
import application from "./application";

application.register("amount-selector", AmountSelectorController);

import ContributionFormController from "./contribution_form_controller";

application.register("contribution-form", ContributionFormController);

import FormWithCaptchaController from "./form_with_captcha_controller";

application.register("form-with-captcha", FormWithCaptchaController);

import IdController from "./id_controller";

application.register("id", IdController);

import SubnavController from "./subnav_controller";

application.register("subnav", SubnavController);
